import React, {ReactElement, ReactNode} from 'react';
import {cx} from '@emotion/css';

import {IconRotation, IconSize} from './types';

import styles from './Icon.styles';

export interface IconProps {
  className?: string;
  rotation?: IconRotation;
  size?: IconSize;
  testId?: string;
  viewBox?: string;
  fill?: string;
}

interface IconWrapperProps extends IconProps {
  children: ReactNode;
}

function IconWrapper({
  children,
  className,
  rotation = IconRotation.NONE,
  size = IconSize.MEDIUM,
  testId,
  viewBox = '0 0 24 24',
  fill,
}: IconWrapperProps): ReactElement {
  return (
    <svg
      className={cx(styles.icon(size, rotation), className)}
      data-testid={testId}
      fill={fill || 'currentColor'}
      version="1.1"
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      style={{fillRule: 'evenodd', clipRule: 'evenodd'}}
    >
      {children}
    </svg>
  );
}

// @todo: Change all the imports to import from the types
export {IconRotation, IconSize} from './types';
export default IconWrapper;
